<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="fmhead"><i>Acknowledgment</i></p>
<p class="noindent">I would like to thank my husband, Alan, for being the IT guy on this book. As a self-confessed technophobe, I can honestly say he had his work cut out for him from the word go (and then some). Thanks, Big Guy. x x x</p>
<p class="noindent">A special thank you to the wonderful people at C&amp;T publishing. They were always there to sort out any queries and keep me on the right track. Their kindness and help made writing this book a very positive experience.</p>
<p class="noindent1">A heartfelt thank you to you all.</p>
<p class="image"><img alt="" src="images/pg4_1.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_acknowledgment.vue?423287ad